import { Space, Tooltip } from "antd"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons"
import { faCircleCheck as faCircleCheckRegular } from "@fortawesome/pro-regular-svg-icons/faCircleCheck"
import { gold, green } from "@ant-design/colors"

type Props = {
  balance: number
  isFullyPaid: boolean
  hasPaymentProblem?: boolean
  hasPendingPayment?: boolean
}

const BalanceDisplay = ({ balance, isFullyPaid, hasPaymentProblem, hasPendingPayment }: Props) => {
  return <Space>
    {centsToDollarsDisplay(balance)}
    {hasPendingPayment && <Tooltip title="Payment processing">
      <FontAwesomeIcon icon={faCircleCheckRegular} color={green.primary} />
    </Tooltip>}
    {isFullyPaid && !hasPendingPayment && <Tooltip title="Fully paid">
      <FontAwesomeIcon icon={faCircleCheck} color={green.primary} />
    </Tooltip>}
    {hasPaymentProblem && <Tooltip title="A payment for this invoice failed or was canceled. You may collect another payment.">
      <FontAwesomeIcon icon={faTriangleExclamation} color={gold[7]} />
    </Tooltip>}
  </Space>
}

export default BalanceDisplay